export enum TrainingLearningActionType {
    FETCH_TRAINING_LEARNING = 'FETCH_TRAINING_LEARNING',
    FETCH_SELECTED_TRAINING_LEARNING = 'FETCH_SELECTED_TRAINING_LEARNING'
  }
